import React from "react";
import PrivacyNotice from "./PrivacyNotice";

const Footer2 = () => {
  return (
    <footer className="footer-modern">
      <div className="footer-content">
        {/* Copyright */}
        <div className="footer-section footer-copyright">
          <span className="copyright">
            &copy; {new Date().getFullYear()} GROB. Todos los derechos reservados.
          </span>
        </div>

        {/* Redes Sociales */}
        <div className="footer-section footer-social">
          <ul className="social-buttons-modern">
            <li>
              <a
                href="https://www.facebook.com/suspensiongrob"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Facebook"
              >
                <i className="fab fa-facebook-f"></i>
              </a>
            </li>
          </ul>
        </div>

        {/* Aviso de Privacidad */}
        <div className="footer-section footer-links">
          <a
            href="#AvisoPrivacidad"
            data-toggle="modal"
            data-target="#avisoPrivacidad"
          >
            Privacidad
          </a>
        </div>
      </div>
      <PrivacyNotice />
    </footer>
  );
};

export default Footer2;
